import React, { useState } from "react";
import { Box, Typography, Dialog, DialogContent, Modal, Button } from "@mui/material";
import AccessTimeOutlinedIcon from "@mui/icons-material/AccessTimeOutlined";
import CloseIcon from "@mui/icons-material/Close";
import Barcode from "react-barcode";
import { theme } from "../../Assets/Theme/theme";
import TimeSlots from "./TimeSlots";

function DetailsSection({ data, dateData }) {
  const [open, setOpen] = useState(false);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const containsUl = (htmlString) => {
    return /<ul>/i.test(htmlString);
  };

  console.log(data?.termAndCondition, "TESTING");

  return (
    <Box sx={{ mt: 4 }}>
      {/* <Typography
        variant="p"
        sx={{
          mb: 1,
          display: "flex",
          alignItems: "center",
          gap: 1,
          color: theme.colors.textLight,
          mb: 2,
        }}
      >
        <AccessTimeOutlinedIcon /> {`${data?.operatingHours?.from} - ${data?.operatingHours?.to}` || "Duration not available"}
      </Typography> */}
      {/* <TimeSlots data={data} /> */}

      <Typography
        variant="h6"
        sx={{ fontWeight: 600, mt: 3, mb: 1, color: theme.colors.text }}
      >
        Description
      </Typography>
      <Typography
        sx={{
          color: theme.colors.textLight,
          "& ul, & ol": {
            ml: 4,
          },
        }}
        dangerouslySetInnerHTML={{ __html: data?.description }}
      />

      <Typography variant="h6" sx={{ fontWeight: 600, mt: 3, mb: 1 }}>
        Highlights
      </Typography>
      <Typography
        sx={{
          color: theme.colors.textLight,
          "& ul, & ol": {
            ml: 4,
          },
        }}
        dangerouslySetInnerHTML={{ __html: data?.highlights }}
      />

      <Typography variant="h6" sx={{ fontWeight: 600, mt: 3, mb: 1 }}>
        Inclusions
      </Typography>
      <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
        {data?.inclusions == "" ? (
          <Typography sx={{ color: theme.colors.textLight }}>
            No inclusions available.
          </Typography>
        ) : (
          data?.inclusions?.map((inclusion, index) => (
            <Typography
              sx={{
                color: theme.colors.textLight,
                "& ul, & ol": {
                  ml: 4,
                },
              }}
              key={index}
              dangerouslySetInnerHTML={{ __html: inclusion }}
            />
          ))
        )}
      </Box>

      <Typography variant="h6" sx={{ fontWeight: 600, mt: 3, mb: 1 }}>
        Exclusions
      </Typography>
      <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
        {data?.exclusions == "" ? (
          <Typography sx={{ color: theme.colors.textLight }}>
            No exclusions available.
          </Typography>
        ) : (
          data?.exclusions?.map((exclusion, index) => (
            <Typography
              sx={{
                color: theme.colors.textLight,
                "& ul, & ol": {
                  ml: 4,
                },
              }}
              key={index}
              dangerouslySetInnerHTML={{ __html: exclusion }}
            />
          ))
        )}
      </Box>

      <Typography variant="h6" sx={{ fontWeight: 600, mt: 3, mb: 1 }}>
        Know Before You Go
      </Typography>
      <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
        {data?.knowBeforeYouGo?.length > 0 ? (
          data?.knowBeforeYouGo?.map((info, index) => (
            <Typography
              sx={{
                color: theme.colors.textLight,
                "& ul, & ol": {
                  ml: 4,
                },
              }}
              key={index}
              dangerouslySetInnerHTML={{ __html: info }}
            />
          ))
        ) : (
          <Typography sx={{ color: theme.colors.textLight }}>
            No additional information available.
          </Typography>
        )}
      </Box>

      <Dialog open={open} onClose={handleClose} maxWidth="sm">
        <DialogContent
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Barcode
            value="123456789"
            width={3}
            height={100}
            displayValue={false}
          />
        </DialogContent>
      </Dialog>
    </Box>
  );
}

export default DetailsSection;
